import { render, staticRenderFns } from "./WorkspaceGeneTraitLocusZoomPane.vue?vue&type=template&id=cfe1fd5c&scoped=true"
import script from "./WorkspaceGeneTraitLocusZoomPane.vue?vue&type=script&lang=js"
export * from "./WorkspaceGeneTraitLocusZoomPane.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGeneTraitLocusZoomPane.vue?vue&type=style&index=0&id=cfe1fd5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe1fd5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe1fd5c')) {
      api.createRecord('cfe1fd5c', component.options)
    } else {
      api.reload('cfe1fd5c', component.options)
    }
    module.hot.accept("./WorkspaceGeneTraitLocusZoomPane.vue?vue&type=template&id=cfe1fd5c&scoped=true", function () {
      api.rerender('cfe1fd5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGeneTraitLocusZoomPane.vue"
export default component.exports